import {
    GET_CUTOMER_PRIORITY_REQUEST,
    GET_CUTOMER_PRIORITY_SUCCESS,
    GET_CUTOMER_PRIORITY_ERROR,
} from "../actions/types";



export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {


        case GET_CUTOMER_PRIORITY_REQUEST:
            return {
                loading: true,
            };
        case GET_CUTOMER_PRIORITY_SUCCESS:
            return {
                ...state,
                loading: false,
                payload
            };
        case GET_CUTOMER_PRIORITY_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        default:
            return state;
    }
}
